import React, { useEffect } from 'react';
import AnnouncementBar from './AnnouncementBar';
import Header from './Header';
import Footer from './Footer';
import { serviceAreas } from '../data/serviceAreas';

const ServiceAreasPage = () => {
  useEffect(() => {
    document.title = 'Service Areas | Pronto Notary Maryland';
    const description = 'Explore Pronto Notary mobile and online service areas across Prince George’s, Howard, and Montgomery counties.';
    let tag = document.querySelector('meta[name="description"]');

    if (!tag) {
      tag = document.createElement('meta');
      tag.name = 'description';
      document.head.appendChild(tag);
    }

    tag.content = description;
  }, []);

  return (
    <PageShell>
      <section className="bg-cream-dark px-6 pb-20 pt-16 md:pb-28 md:pt-24">
        <div className="mx-auto max-w-7xl">
          <div className="max-w-3xl">
            <Eyebrow>WHERE WE TRAVEL</Eyebrow>
            <h1 className="font-fraunces text-5xl leading-tight text-navy md:text-7xl">
              Mobile Notary <span className="italic text-brass">Across the DMV.</span>
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-navy/70">
              Based in Laurel, we cover Prince George&apos;s, Howard, and Montgomery counties, in person or online. Find your city below, or reach out if you don&apos;t see it listed.
            </p>
          </div>

          <div className="mt-16 grid grid-cols-2 gap-4 lg:grid-cols-4">
            {serviceAreas.map((area) => (
              <a
                key={area.slug}
                href={`/mobile-notary/${area.slug}`}
                className={`group rounded-2xl border p-6 transition-all hover:-translate-y-1 hover:border-brass hover:shadow-md ${
                  area.slug === 'laurel'
                    ? 'border-brass bg-navy text-cream'
                    : 'border-line bg-cream text-navy'
                }`}
              >
                <span className={`text-xs font-bold uppercase tracking-[0.15em] ${
                  area.slug === 'laurel' ? 'text-brass-light' : 'text-brass'
                }`}>
                  {area.countyLabel}
                </span>
                <h2 className="mt-5 font-fraunces text-2xl">{area.name}, MD</h2>
                <span className={`mt-8 inline-flex text-sm font-bold transition-colors ${
                  area.slug === 'laurel' ? 'text-cream/80 group-hover:text-brass-light' : 'text-navy group-hover:text-brass'
                }`}>
                  Explore {area.name} <span className="ml-2" aria-hidden="true">→</span>
                </span>
              </a>
            ))}
          </div>

          <p className="mt-12 text-center font-fraunces text-2xl italic text-navy/80">
            Don&apos;t see your town? Call or text, we probably still cover it.
          </p>

          <div className="mt-8 flex justify-center">
            <a
              href="tel:2405713117"
              className="inline-flex items-center justify-center rounded-full border border-navy px-6 py-3 text-sm font-bold text-navy transition-colors hover:bg-navy hover:text-cream"
            >
              Call or Text (240) 571-3117
            </a>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

const PageShell = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-cream selection:bg-brass selection:text-cream">
    <AnnouncementBar />
    <Header />
    <main className="flex-grow">{children}</main>
    <Footer />
  </div>
);

const Eyebrow = ({ children }) => (
  <span className="mb-5 block text-xs font-bold uppercase tracking-[0.2em] text-brass">
    {children}
  </span>
);

export default ServiceAreasPage;